module.exports = __webpack_public_path__ + "img/icon-notification.c62dcbbd.svg";